/* @flow */
import React from 'react';
import { debounce } from 'lodash';

import Dialog from 'components/Dialog';
import BoxBody from 'components/BoxBody';
import BoxHeader from 'components/BoxHeader';
import Heading from 'components/Heading';
import MediaObject from 'components/MediaObject';
import SearchBlock from 'components/SearchBlock';
import Text from 'components/Text';
import Image from 'components/Image';

import ComposerIntegrationsContentList from './ComposerIntegrationsContentList';
import './styles/ComposerIntegrationsContent.scss';

type Props = {
  onViewSources: (reloadData: boolean) => void,
  addLinkedContent: (*) => void,
  contentSource: *,
};

type State = {
  query: string,
  queryFailed: boolean,
};

class ComposerIntegrationsContent extends React.Component<Props, State> {
  state = {
    query: '',
    queryFailed: false,
  };

  performSearch = (rawQuery: string = '') => {
    const query = rawQuery.trim();
    this.setState({
      query,
    });
  };

  handleQueryFailed = () => {
    const { queryFailed } = this.state;

    if (!queryFailed) {
      this.setState({ queryFailed: true });
    }
  };

  handleQueryChange = debounce(this.performSearch, 500, { leading: false, trailing: true });

  render() {
    const { contentSource, onViewSources, addLinkedContent } = this.props;
    const { query, queryFailed } = this.state;

    return (
      <Dialog
        data-test="composer-integrations-content-dialog"
        size="xxsmall"
        className="ComposerIntegrationsContent"
        onRequestHide={() => onViewSources(queryFailed)}>
        <BoxHeader
          size="xxsmall"
          title={
            <MediaObject gutter="small" className="ComposerIntegrationsContent-title">
              <Image
                className="ComposerIntegrationsContent-headerIcon"
                src={contentSource.iconURL}
              />
              <Heading flush>
                <Text>{contentSource.title}</Text>
              </Heading>
            </MediaObject>
          }
          textAlign="left"
          flush
        />
        <BoxBody full>
          <SearchBlock
            size="small"
            label="Search"
            className="ComposerIntegrationsContent-search"
            onDismiss={() => {}}
            onQueryChange={this.handleQueryChange}
            data-test="composer-integrations-content-search-input"
            data-test-selector="linked_content_search_input"
          />
          <div className="ComposerIntegrationsContent-content">
            <ComposerIntegrationsContentList
              contentSource={contentSource}
              query={query}
              addLinkedContent={addLinkedContent}
              onQueryFailed={this.handleQueryFailed}
              data-test="composer-integrations-content-list"
            />
          </div>
        </BoxBody>
      </Dialog>
    );
  }
}

export default ComposerIntegrationsContent;
